import { useMemo } from 'react';
import { useSourceAccountsQuery } from '../../api/useSourceAccountsQuery';

interface Params {
  year: number | null;
  accountOwner: string | null;
  fpId: string;
  isAnnuityQualified: boolean;
  isApplied: boolean;
}

export const usePurchaseAmountForm = ({
  year,
  accountOwner,
  fpId,
  isAnnuityQualified,
  isApplied,
}: Params) => {
  const queryResult = useSourceAccountsQuery({
    year,
    fpId,
    accountOwner,
    isApplied,
  });

  const data = useMemo(() => {
    if (!queryResult.data) {
      return {
        accountOptions: [],
        sourceAccounts: [],
      };
    }

    const { SourcesForNonQualifiedAnnuities, SourcesForQualifiedAnnuities } = queryResult.data;

    const sourceAccounts = isAnnuityQualified
      ? SourcesForQualifiedAnnuities
      : SourcesForNonQualifiedAnnuities;

    return {
      sourceAccounts,
      accountOptions: sourceAccounts.map(source => ({
        label: source.Name,
        value: source.Id,
        metaData: {
          SimulatedAccountType: source.SimulatedAccountType,
          IsSimulatedSource: source.IsSimulatedSource,
          EntityId: source.EntityId,
        },
      })),
    };
  }, [isAnnuityQualified, queryResult.data]);

  return {
    ...queryResult,
    data,
  };
};
